module.exports = __webpack_public_path__ + "img/Engie Pro.3612d7f9.png";